import React, { Component } from 'react';
import { Link} from 'react-router-dom';
import './about.css';

class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            about : [],
            aboutPic: []                  
        };
      }

    componentDidMount() {
        this.getAbout();
      }
    
      // Retrieves the list of items from the Express app
      getAbout = () => {
        fetch('/api/about')
        .then(res => res.json())
        .then(data=> this.setState({ about: data.about, aboutPic: data.aboutPic }));


      }

    featMove = (e) => {
        this.props.parentMove(e);
    }

    render() {
        const { about } = this.state;
        const { aboutPic } = this.state;
 
        
        return (
            <React.Fragment>
                   
                   <div className= "aboutState centerT blkT parallax "> <p className="centeredContent"><span className="outlineT">We are</span><br/>Black<br/>Americans<br/><span className="outlineT">Who</span></p></div>
                {about.length ? (

                     <div className="mapContent hoverRed aboutContent" style={{"opacity": this.props.mapVis[0]}} >
                        {/* Render the list of items */}
                        {about.map((about, i) => {
                        return(
                            <React.Fragment key={i}>
                                
                                
                                <div className= "fullStage marginBotHuge aboutIntro" dangerouslySetInnerHTML={{ __html : about.aboutIntro }}></div>
                                <div className="aboutStateHold relative">
                                    
                                <div className="fullStage"><div className= "tfStage weAreList centerT relative" dangerouslySetInnerHTML={{ __html : about.aboutStateList }}></div></div>
                                </div>
                                <div className= "fullStage"><h1 className= "tfStage marginBotSmall" dangerouslySetInnerHTML={{ __html : about.aboutMissionTitle }}></h1>
                                    <div className= "tfStage missionList marginBotLarge" dangerouslySetInnerHTML={{ __html : about.aboutMissionList }}></div>
                                </div>
                                
                                {aboutPic.length ? (
                                            <div className="bgCover aboutPrincipleBG fullWidth fullHeight" style={{backgroundImage: `url(${aboutPic[0].imgURL})`}} >
                                            <div className="fullStage aboutPrincInfo centeredContent relative">
                                                <p className=" boldT upperT marginBotSmall titleFont" dangerouslySetInnerHTML={{ __html : about.aboutPTitle }}></p>
                                                <h1 className="">BSA: Core Principles and Objectives</h1>
                                                <Link to='/features/principles' data-id="4" data-name="features" onClick={this.props.parentMove.bind(this)}>
                                                <div className="buttonCTA buttonText">
                                                <p>READ MORE</p>
                                                </div>
                                                </Link>
                                            </div> 
                                            </div>
                                        
                                    ):('')}   
                                    
                               

                                

                                
                                
                            </React.Fragment>
                        );
                        })}
                    </div>
                    ) : (
                        <div className="fullWidth fullHeight redT blinkFast loader">
                        <div className="centeredContent">•</div>
                    </div>
                    
                    )
                }
            </React.Fragment>
        )
    }
  }
  
  export default About




// WEBPACK FOOTER //
// ./src/components/about/about.js